exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".serv{\n    margin: 2rem !important;\n}\n\n.serv ul {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    padding-left: 0;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n  }\n  \n  .serv ul li {\n    list-style: none;\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/layouts/header/header.component.css
// module id = ../../../../../src/app/layouts/header/header.component.css
// module chunks = main